<template>
  <article :class="['video-card-featured', dark && 'video-card-featured-dark']">
    <router-link v-if="img" :to="to">
      <div class="video-card-featured-img">
        <img
          :src="img"
          :alt="title"
          :title="title"
          loading="lazy"
          @error="invalidImage = true"
        />
      </div>
    </router-link>
    <div class="text-h6 font-weight-bold video-card-featured-title mt-2">
      <router-link
        :to="to"
        v-html="title"
        :class="[
          'text-decoration-none roboto-condensed',
          !dark ? 'grey--text text--darken-2' : 'white--text',
        ]"
      ></router-link>
    </div>
    <time
      :class="[
        'text-body-2',
        !dark ? 'grey--text text--darken-2' : 'white--text',
      ]"
      v-if="localeDate"
      :datetime="ISODate"
    >
      {{ localeDate }}
    </time>
  </article>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
    ISODate: {
      type: String,
      required: true,
    },
    localeDate: {
      type: String,
      required: true,
    },
    dark: {
      type: Boolean,
    },
  },
};
</script>

<style>
.video-card-featured {
  position: relative;
}

.video-card-featured-img {
  position: relative;
  aspect-ratio: 16 / 9;
  border: 1px solid #ddd;
}

.video-card-featured-img::before {
  background-image: url(/img/play.svg);
  background-repeat: no-repeat;
  background-size: contain;
  content: "";
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  opacity: 0.7;
  position: absolute;
  top: 50%;
  transition: all 0.1s linear;
  width: 50px;
  z-index: 90;
}
.video-card-featured:hover .video-card-featured-img::before {
  opacity: 0.9;
}

.video-card-featured img {
  aspect-ratio: 16 / 9;
  display: block;
  object-fit: cover;
  width: 100%;
}

.video-card-featured img,
.video-card-featured-title,
.video-card-featured-category {
  transition: all 0.1s linear;
}

@media screen and (max-width: 1264px) {
  .video-card-featured-title {
    font-size: 14px;
  }
}

.video-card-featured:hover img {
  opacity: 0.8;
}

.video-card-featured:hover .video-card-featured-title a {
  color: var(--v-secondary-lighten2) !important;
}
.video-card-featured-dark:hover .video-card-featured-title a {
  color: #ddd !important;
}
</style>
